// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"496":"337ccce4","626":"239865f2","916":"7d05eb15"}[chunkId] + ".chunk.js";
};